import { render } from "./DemandForecastingSettingsGrid.vue?vue&type=template&id=6c0c2cd8"
import script from "./DemandForecastingSettingsGrid.vue?vue&type=script&lang=js"
export * from "./DemandForecastingSettingsGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__